import React from 'react';
import { ArrowRight, BoxIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
interface ServiceCardProps {
  icon: BoxIcon;
  title: string;
  description: string;
  linkTo: string;
}
export function ServiceCard({
  icon: Icon,
  title,
  description,
  linkTo
}: ServiceCardProps) {
  const {
    t
  } = useLanguage();
  return <div className="group relative bg-white p-8 rounded-2xl border border-gray-100/50 hover:border-red-100 shadow-premium hover:shadow-premium-xl transition-all duration-500 h-full flex flex-col overflow-hidden hover-lift" data-id="element-250">
      {/* Background gradient effect */}
      <div className="absolute inset-0 bg-gradient-to-br from-red-50/0 via-transparent to-red-50/30 opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-251"></div>

      {/* Icon container */}
      <div className="relative z-10 mb-6" data-id="element-252">
        <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-red-50 to-red-100/50 flex items-center justify-center text-[#C4161C] group-hover:scale-110 group-hover:rotate-3 transition-all duration-500 shadow-sm" data-id="element-253">
          <Icon className="w-8 h-8" strokeWidth={1.5} data-id="element-254" />
        </div>
      </div>

      <h3 className="relative z-10 text-xl font-bold text-gray-900 mb-4 heading-premium group-hover:text-[#C4161C] transition-colors duration-300" data-id="element-255">
        {title}
      </h3>

      <p className="relative z-10 text-gray-600 mb-6 flex-1 leading-relaxed text-sm" data-id="element-256">
        {description}
      </p>

      <Link to={linkTo} className="relative z-10 inline-flex items-center font-bold text-[#C4161C] group-hover:text-[#A01217] transition-all duration-300 group/link text-sm" data-id="element-257">
        <span className="mr-2" data-id="element-258">{t('Pelajari Lebih Lanjut', 'Learn More')}</span>
        <ArrowRight className="w-4 h-4 group-hover/link:translate-x-1 transition-transform duration-300" data-id="element-259" />
      </Link>

      {/* Decorative corner */}
      <div className="absolute bottom-0 right-0 w-24 h-24 bg-gradient-to-tl from-[#C4161C]/5 to-transparent rounded-tl-full opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-260"></div>
    </div>;
}